// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  systemId: __t.string().primaryKey().name("system_id"),
  lod: __t.u8(),
  authorityEpoch: __t.u64().name("authority_epoch"),
  observers: __t.u32(),
  lastPresenceAt: __t.timestamp().name("last_presence_at"),
  changedAt: __t.timestamp().name("changed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
